import { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Taxonomy } from "@common/categories";
import { useStandardCategories } from "@hooks/useStandardCategories";
import { PaginatedTransactionsActionsContext } from "./PaginatedTransactionsTable.context";

export function useChangeTransactionToPersonal(
    transaction: TransactionListItem,
) {
    const { saveTransaction } = useContext(PaginatedTransactionsActionsContext);
    const categories = useStandardCategories();

    return useMutation({
        mutationFn: async () => {
            const previousEntity = transaction.entity;

            if (!previousEntity.isPersonal) {
                return await saveTransaction(transaction, {
                    categoryId: categories[Taxonomy.personal].id,
                });
            }
        },
    });
}
